import { NgayPhepTrongNam } from "@app/models/donnghiphep/NgayPhepTrongNam";
import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import intance from "../utils/axios";
import { CauHinhNguoiMacDinhReponse, CauHinhNguoiYKienReponse, CauHinhReponse, DanhSachNhanVienDuocDuyet, DanhSachNhanVienDuocYKien, DonNghiPhep, TimKiemDonNghiPhepRequest } from "@app/models/donnghiphep/DonNghiPhep";
import { NhanVienResponse } from "../models/nhanvien/NhanVien";

export const luuDonNghiPhep = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.donNghiPhep.LuuDonNghiPhep, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const layThongTinNgayPhepTrongNam = async (namNghiPhep: number) => {
    var data = new NgayPhepTrongNam;
    await intance.get(ApiPaths.donNghiPhep.LayThongTinNgayPhepTrongNam + "?nam=" + namNghiPhep)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layNguoiPheDuyet_YKienPhepMacDinh = async () => {
    var data = new CauHinhNguoiMacDinhReponse;
    await intance.get(ApiPaths.donNghiPhep.LayNguoiDuyet_YKienPhepMacDinh)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const timKiemDonNghiPhep = async (tuKhoa: string, nam: string, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.donNghiPhep.LayDsDonNghiPhep, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": tuKhoa,
            "thoiGian":nam
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layChiTiet = async (id: number) => {
    var data = new DonNghiPhep;
    await intance.get(ApiPaths.donNghiPhep.LayCT + "?id=" + id)
        .then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        }else{
            throw res.data.thongBao
        }
    })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const xoaDonNghiPhep = async (id: number) => {
    await intance.get(ApiPaths.donNghiPhep.Xoa + "?id=" + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const duyetDonNghiPhep = async (request: any) => {
    await intance.post(ApiPaths.donNghiPhep.DuyetDonNghiPhep, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const huyDonNghiPhep = async (request: any) => {
    await intance.post(ApiPaths.donNghiPhep.HuyDonNghiPhep, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const duaYKienDonNghiPhep = async (request: any) => {
    await intance.post(ApiPaths.donNghiPhep.DuaYKien, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}


export const layDanhSachTongHopTheoThang = async (request: TimKiemDonNghiPhepRequest) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.donNghiPhep.layDanhSachTongHopTheoThang, {
        "start": 0,
        "length": 0,
        "filter": {
            "tuKhoa": request.tuKhoa,
            "ngayTaoTuNgay": request.ngayTaoTuNgay,
            "ngayTaoDenNgay": request.ngayTaoDenNgay,
            "ngayBatDauTuNgay": request.ngayBatDauTuNgay,
            "ngayBatDauDenNgay": request.ngayBatDauDenNgay,
            "ngayKetThucTuNgay": request.ngayKetThucTuNgay,
            "ngayKetThucDenNgay": request.ngayKetThucDenNgay
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const timKiemDonNghiPhepCaNhan = async (tuKhoa: string, nam: string, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.donNghiPhep.LayDsDonNghiPhepCaNhan, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": tuKhoa,
            "thoiGian": nam
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDanhSachNguoiDuyet = async () => {
    var rs :Array<NhanVienResponse> = [];
    await intance.get(ApiPaths.donNghiPhep.LayDsNguoiDuyet)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const layDanhSachNguoiYKien = async () => {
    var rs: Array<NhanVienResponse> = [];
    await intance.get(ApiPaths.donNghiPhep.LayDsNguoiYKien)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const layDanhSachNhanVienTheoNguoiDuyet = async (id:number) => {
    var rs: Array<CauHinhReponse> = [];
    await intance.get(ApiPaths.donNghiPhep.LayDSNvTheoNguoiDuyet + "?idNhanVienDuyet=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const layDanhSachNhanVienTheoNguoiYKien = async (id: number) => {
    var rs: Array<CauHinhNguoiYKienReponse> = [];
    await intance.get(ApiPaths.donNghiPhep.LayDSNvTheoNguoiYKien + "?idNhanVienYKien=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const luuDsNhanVien = async (request: DanhSachNhanVienDuocDuyet) => {
    var rs = false;
    await intance.post(ApiPaths.donNghiPhep.LuuNhanVienTheoNguoiDuyet, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch((error) => {
            throw error;
        })
    return rs;
};

export const luuDsNhanVienYKien = async (request: DanhSachNhanVienDuocYKien) => {
    var rs = false;
    await intance.post(ApiPaths.donNghiPhep.LuuNhanVienTheoNguoiYKien, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch((error) => {
            throw error;
        })
    return rs;
};

export const TimKiemNgayPhepTrongNam = async (nam: string, tuKhoa: string, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.ngayPhepTrongNam.layDanhSachNgayPhepTrongNam, {
        "start": start,
        "length": length,
        "filter": {
            "thoiGian": nam,
            "tuKhoa": tuKhoa
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuNgayPhepTrongNam = async (data: any) => {
    await intance.post(ApiPaths.ngayPhepTrongNam.luuNgayPhepTrongNam, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const khoiTaoPhepNam = async (nam: any) => {
    await intance.post(ApiPaths.ngayPhepTrongNam.khoiTaoPhepNam + "?nam=" + nam)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
}

export const layDsNghiPhepTrongNamTheoNhanVien = async (tuNgay: Date, denNgay: Date, idNhanVien: number) => {
    var data: Array<NgayPhepTrongNam> = [];
    await intance.post(ApiPaths.ngayPhepTrongNam.getListAnnualLeave, { "tuNgay": tuNgay, "denNgay": denNgay, "idNhanVien": idNhanVien })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDanhSachDonNghiPhepChoPheDuyet = async () => {
    var rs: any;
    await intance.get(ApiPaths.donNghiPhep.layDSDonNghiPhepChoPheDuyet)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const thuHoiNghiPhep = async (request: any) => {
    await intance.post(ApiPaths.donNghiPhep.ThuHoiNghiPhep + "?id=" + request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
} 

export const yeuCauHuyNghiPhep = async (request: any) => {
    await intance.post(ApiPaths.donNghiPhep.YeuCauHuyNghiPhep + "?id=" + request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}